module.exports = __webpack_public_path__ + "img/15.3836047f.svg";